<template>
  <div class="searchBar" v-bind:class="[orientation]">
    <div class="row title" v-if="showTitle">
      <h2>{{t('Search:')}}</h2>
    </div>
    <form>
      <div class="row">
        <div class="col-md-4 location">
          <SearchLocation></SearchLocation>
        </div>
        <!--div class="col-md-3">
          <Text-Input :data="form.what"></Text-Input>
          </div-->
          <div class="col-md-3 startDate">
            <DatePicker :data="startDate" v-model="search.startDate" aditionalClass="lightOnDark" v-on:input="changeStartDate(arguments[0])"></DatePicker>
          </div>
          <div class="col-md-3 endDate">
            <DatePicker :data="endDate" v-model="search.endDate" aditionalClass="lightOnDark" v-on:input="changeEndDate(arguments[0])"></DatePicker>
          </div>
          <div class="col-md-2 actions">
            <button type="button" class="btn btn-success btn-lg searchButton" v-on:click="searchActivities()"><i class="fa fa-search"></i></button>
          </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInputSearchBar from '../Form/TextInputSearchBar';
import DatePicker from '../Form/DatePicker';
import SearchLocation from './SearchLocation';

export default {
  name: 'searchBar',
  components: {
    'Text-Input': TextInputSearchBar,
    DatePicker,
    SearchLocation,
  },
  props: {
    orientation: { default: 'horizontal' },
    showTitle: { default: false },
  },
  data() {
    return {
      startDate: {
        id: 'DatePickerStartDate',
        label: 'From date',
      },
      endDate: {
        id: 'DatePickerEndDate',
        label: 'Until Date',
      },

      // THIS WAS FROM THE MOCKUP
      form: {
        location: {
          name: 'location',
          value: 'Portugal',
          label: 'Location',
          icon: 'fa-map-marker',
          errors: [],
        },
        what: {
          name: 'what',
          value: '',
          label: 'What to do',
          icon: 'fa-bicycle',
          errors: [],
        },
        from: {
          name: 'from',
          value: '',
          label: 'From',
          icon: 'fa-calendar-o',
          errors: [],
        },
        to: {
          name: 'to',
          value: '',
          label: 'To',
          icon: 'fa-calendar-o',
          errors: [],
        },
      },
    };
  },
  computed: {
    ...mapState({
      search: state => state.search,
      language: state => state.language,
    }),
  },
  methods: {
    changeStartDate(date) {
      this.$store.dispatch('search/setSearchStartDate', date);
    },
    changeEndDate(date) {
      this.$store.dispatch('search/setSearchEndDate', date);
    },
    searchActivities() {
      this.$router.push(
        `/${this.language}/search?startDate=${this.search.startDate}&endDate=${this.search.endDate}&location=${this.search.location.value}` // eslint-disable-line
      );
      this.$emit('search');
    },
  },
};
</script>
<style lang="scss">
.searchBar {
  input[type=text] {
    height: 1.6rem;
  }
}
</style>

<style lang="scss" scoped>
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";

.helpText {
  position: absolute;
  bottom: 15px;
  left: 45px;
  z-index: 2;
  font-size: 12px;
  color: rgba(255,255,255, 0.6);
}
.searchBar {
  position: relative;
  padding-top: 21px;
  padding-bottom: 25px;
  padding-left: 15px;
  background-color: rgba(0,130,97, 0.8);
  /* background-color: #008261;*/

  .title {
    color: white;
    padding: 15px;
  }
  .searchButton {
    background: white;
    color: #2e7d32  !important;
    width: 75%;
    font-size: 16px;
  }
  .searchButton:hover {
    color: white !important;
  }
  .location, .startDate, .endDate, .searchButton {
    margin-top: 24px;
  }

  .datepicker {
    padding-bottom: 0 !important;
  }

}
  .searchBar.vertical {
    box-shadow: 2px 2px 10px rgba(0,0,0, 0.4);
    margin-left: 0;
    margin-right: 0;
    min-height: 50vh;
    padding: 15px;
    .location, .startDate {
      margin-top: 30px;
      width: 100%;
    }
    .endDate, .actions {
      width: 100%;
    }
    .actions {
      margin-top: 5vh;
    }
    .searchButton {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media #{$medium-and-down}{
    .searchBar .searchButton {
      max-width: 150px;
      margin-bottom: 40px;
    }
  }

  @media #{$small-and-down}{
    .helpText {
      left: 0;
      right: 0;
      text-align: center;
    }
  }

  @media #{$large-and-up} {
    .searchBar {
      margin-left: 15%;
      margin-right: 15%;
    }
  }

</style>



// WEBPACK FOOTER //
// Search.vue?38124fb3